export enum EPlanAction {
  Join = 'join',
  Leave = 'leave',
}
